<template>
  <v-container grid-list-xl class="pa-0">
    <v-layout wrap>
      <v-flex xs5>
        <m-card-list
          title="Anggota"
          show-select
          v-model="selection"
          :items="items"
          item-key="user_id"
          :headers="headers"
          :page="page"
          @change:page="(pg)=>{cp=pg;load()}"
        >
          <template v-slot:items="{props,item}"><tr>
            <td>
              <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
            </td>
            <td>{{item.user_id}}</td>
            <td>{{item.nama}}</td>
            </tr>
          </template>
        </m-card-list>
      </v-flex>
      <v-flex xs1>
        <v-btn depressed fab color="red" small>
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs6>
        <m-card-list
          title="User Terpilih"
          :select="selectAll"
          :items="selection"
          :headers="headers"
          :page="page"
          @change:page="(pg)=>{cp=pg;load()}"
        >
          <template v-slot:items="{props,item}"><tr>
            <td>{{item.user_id}}</td>
            <td>{{item.nama}}</td>
            </tr>
          </template>
        </m-card-list>
      </v-flex>
    </v-layout>
    <!-- <ChangeDlg ref="dlg"/> -->
  </v-container>
</template>
<script>
// import ChangeDlg from "../components/FormJamKerja.vue";
import BlockCard from "@/components/BlockCard";
import MChartPie from "@/components/MChartPie";
import MChartBar from "@/components/MChartBar";

export default {
  components: {
    // ChangeDlg,
    BlockCard,
    MChartPie,
    MChartBar
  },
  data() {
    return {
      items: [],
      selection: [],
      itemSelected: [],
      selectAll: true,
      page: null,
      cp: 1,
      headers: [
        { text: "ID", align: "left", value: "user_id" },
        { text: "Nama", align: "left", value: "nama" }
      ]
    };
  },
  mounted() {
    this.load();
  },
  watch: {},
  methods: {
    load() {
      this.$store
        .dispatch("user/get", { page: this.cp })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg
        .open()
        .then(() => {
          this.load();
        })
        .catch(e => e);
    },
    edit(item) {
      this.$refs.dlg
        .open(item)
        .then(() => {
          this.load();
        })
        .catch(e => e);
    }
  }
};
</script>
